import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

interface PublishVersionDialogProps {
  open: boolean
  versionLabel: string
  submitting?: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}

export function PublishVersionDialog({ open, versionLabel, submitting = false, onClose, onConfirm }: PublishVersionDialogProps) {
  const handleClose = () => {
    if (submitting) return
    onClose()
  }

  const handleConfirm = async () => {
    await onConfirm()
  }

  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/40" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Dialog.Panel className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
                <Dialog.Title className="text-lg font-semibold text-gray-900">發佈版本</Dialog.Title>
                <Dialog.Description className="mt-2 text-sm text-gray-600">
                  確定要將 <span className="font-medium text-gray-800">{versionLabel}</span> 發佈為正式版本嗎？
                  其他已發佈的版本將自動封存，模板狀態會切換為已發佈。
                </Dialog.Description>

                <div className="mt-6 flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="rounded border border-gray-300 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
                    disabled={submitting}
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    onClick={handleConfirm}
                    className="rounded bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-70"
                    disabled={submitting}
                  >
                    {submitting ? '發佈中…' : '確認發佈'}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default PublishVersionDialog
